/**
 * Created by klyachb1 on 23/02/2017.
 */
import {PostalAddress} from './postal-address';

export class User {
  username: string;
  title: string;
  firstName: string;
  lastName: string;
  accountNumber: string;
  email: string;
  landLine: string;
  mobile: string;
  token: string;
  accountName: string;
  postalAddress: string;
  isNewAccount: boolean;
  approved: boolean;
  userRole: string;
  titleSelected = true;
  currentConsultantSelectedItemId: number;
  consultantRef: string;
  abnNumber: string;
  position: string;
  structuredPostal: PostalAddress;
  isGuestUser: boolean;
  billLater: boolean;
  companyName: string;

  constructor(obj?: any) {
    if (obj) {
      if (obj.hasOwnProperty('username')) {
        this.username = obj.username;
      }
      if (obj.hasOwnProperty('title')) {
        this.title = obj.title;
      }
      if (obj.hasOwnProperty('firstName')) {
        this.firstName = obj.firstName.toUpperCase();
      }
      if (obj.hasOwnProperty('lastName')) {
        this.lastName = obj.lastName.toUpperCase();
      }
      if (obj.hasOwnProperty('accountNumber')) {
        this.accountNumber = obj.accountNumber;
      }
      if (obj.hasOwnProperty('email')) {
        this.email = obj.email;
      }
      if (obj.hasOwnProperty('landLine')) {
        this.landLine = obj.landLine;
      }
      if (obj.hasOwnProperty('mobile')) {
        this.mobile = obj.mobile;
      }
      if (obj.hasOwnProperty('token')) {
        this.token = obj.token;
      }
      if (obj.hasOwnProperty('accountName')) {
        this.accountName = obj.accountName;
      }
      if (obj.hasOwnProperty('abnNumber')) {
        this.abnNumber = obj.abnNumber;
      }
      if (obj.hasOwnProperty('companyName')) {
        this.companyName = obj.companyName;
      }
      if (obj.hasOwnProperty('position')) {
        this.position = obj.position;
      }
      if (obj.hasOwnProperty('postalAddress')) {
        this.postalAddress = obj.postalAddress;
      }
      if (obj.hasOwnProperty('userRole')) {
        this.userRole = obj.userRole;
      } else {
        this.userRole = 'User';
      }
      if (obj.hasOwnProperty('approved')) {
        this.approved = obj.approved;
      } else {
        this.approved = false;
      }
      if (obj.hasOwnProperty('isNewAccount')) {
        this.isNewAccount = obj.isNewAccount
      } else {
        this.isNewAccount = false;
      }
      if (obj.hasOwnProperty('structuredPostal')) {
        this.structuredPostal = obj.structuredPostal;
      } else {
        this.structuredPostal = new PostalAddress();
      }
      if (obj.hasOwnProperty('billLater')) {
        this.billLater = obj.billLater;
      } else {
        this.billLater = false;
      }
    }
    if (!this.structuredPostal) {
      this.structuredPostal = new PostalAddress();
    }
    this.currentConsultantSelectedItemId = 0;
    this.consultantRef = '';
  }

  get fullName(): string {
    let fn = '';
    // Title is removed from the full name as per BB request (re: sprint 2 feedback)
    if (this.firstName) {
      fn += (this.firstName + ' ');
    }
    fn += this.lastName;

    return fn;
  }

  get userRoleDisplay(): string {
    if (!this.userRole) {
      return '';
    } else {
      switch (this.userRole.toLowerCase()) {
        case 'user':
          return 'User';
        case 'admin':
          return 'Administrator';
        case 'sysadmin':
          return 'System Administrator';
        case 'techcso':
          return 'Technical CSO';
      }
    }
  }

  set userRoleDisplay(v: string) {
    switch (v.toLowerCase()) {
      case 'user':
        this.userRole = 'User';
        break;
      case 'administrator':
        this.userRole = 'admin';
        break;
      case 'system administrator':
        this.userRole = 'sysadmin';
        break;
      case 'technical cso':
        this.userRole = 'techcso';
        break;
    }
  }

  toUpperCase() {
    if (this.accountName) {
      this.accountName = this.accountName.toUpperCase();
    }
    if (this.postalAddress) {
      this.postalAddress = this.postalAddress.toUpperCase();
    }
    if (this.landLine) {
      this.landLine = this.landLine.toUpperCase();
    }
    if (this.mobile) {
      this.mobile = this.mobile.toUpperCase();
    }
    if (this.firstName) {
      this.firstName = this.firstName.toUpperCase();
    }
    if (this.lastName) {
      this.lastName = this.lastName.toUpperCase();
    }
    if (this.consultantRef) {
      this.consultantRef = this.consultantRef.toUpperCase();
    }
    if (this.structuredPostal) {
      this.structuredPostal.toUpperCase();
    }
    if (this.companyName) {
      this.companyName.toUpperCase();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/user.ts